import { Link } from "react-router-dom";
import type { Category } from "@/mocks/categories";

const accentMap: Record<string, string> = {
  huati: "bg-primary-100 text-primary-700",
  shijian: "bg-accent-100 text-accent-700",
  renwu: "bg-secondary-200 text-secondary-800",
  jigou: "bg-primary-100 text-primary-800",
};

export default function CategoryCard({ cat }: { cat: Category }) {
  return (
    <Link
      to={`/category/${cat.slug}`}
      className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-100 transition-all hover:-translate-y-1 hover:border-background-300"
    >
      <div className="relative overflow-hidden">
        <img
          src={cat.cover}
          alt={`${cat.name}分类`}
          className="aspect-[16/10] w-full object-cover transition-transform duration-300 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/40 to-transparent"></div>
        <span className="absolute right-3 bottom-3 inline-flex items-center gap-1 rounded-full bg-background-50/90 px-3 py-1 text-xs font-semibold text-foreground-900">
          <i className={`${cat.icon} text-sm`}></i>
          {cat.stat}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <div className="flex items-center justify-between">
          <h3 className="font-heading text-lg font-bold text-foreground-950">{cat.name}</h3>
          <span className={`flex h-8 w-8 items-center justify-center rounded-md text-base ${accentMap[cat.slug]}`}>
            <i className={cat.icon}></i>
          </span>
        </div>
        <p className="mt-1 text-xs font-medium tracking-wide text-primary-600 uppercase">{cat.en}</p>
        <p className="mt-2 text-sm leading-6 text-foreground-600 line-clamp-2">{cat.tagline} · {cat.blurb}</p>
        <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-primary-600 transition-colors group-hover:text-primary-800">
          进入分类
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
        </span>
      </div>
    </Link>
  );
}